import { render, staticRenderFns } from "./AsNextOfKinList.vue?vue&type=template&id=4c87625e&"
import script from "./AsNextOfKinList.vue?vue&type=script&lang=js&"
export * from "./AsNextOfKinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports